import axios from 'lib/axios'

export interface InventoryInvoice {
  id: number
  invoice_number: string
  invoice_date: string
  amount: string
}

export interface NewInventoryInvoice {
  invoice_number: string
  invoice_date: string
  amount: string
}

interface InventoryInvoicesResponse {
  status: 'OK'
  data: InventoryInvoice[]
}

export const getInventoryInvoices = async (inventoryId: number): Promise<InventoryInvoice[]> => {
  const response = await axios.get<InventoryInvoicesResponse>(`/subscription_company/${inventoryId}/invoices`)
  return response.data.data
}

export const createInventoryInvoice = async (
  inventoryId: number,
  invoice: NewInventoryInvoice,
): Promise<InventoryInvoice> => {
  const response = await axios.post<{ status: 'OK'; data: InventoryInvoice }>(
    `/subscription_company/${inventoryId}/invoices`,
    invoice,
  )
  return response.data.data
}
